import { SET_GROUPS, CLEAR_GROUPS } from "../actions/groupsActions";

const initialState = {
  groups: []
}

function groupsReducer(state = initialState, action) {
  switch (action.type) {
  case SET_GROUPS:
    return {
      ...state,
      groups: action.payload
    }
  case CLEAR_GROUPS:
    return {
      ...state,
      groups: []
    }
  default:
    return state;
  }
}

export default groupsReducer;